import { useCallback } from 'react';

export function useCharterValidation(state, setState, vehicleTypeSelectValidatorRef) {
  const validate = useCallback(() => {
    const errors = { ...state.errors };
    let formIsValid = true;

    // Reset all errors
    Object.keys(errors).forEach((k) => { errors[k] = ''; });

    if (state.paxFirstName.trim() === '') { formIsValid = false; errors.paxFirstName = 'Please enter first name.'; }
    if (state.paxLastName.trim() === '') { formIsValid = false; errors.paxLastName = 'Please enter last name.'; }

    if (state.mobileNumber.trim() === '') {
      formIsValid = false; errors.mobileNumber = 'Please enter mobile.';
    } else if (state.mobileNumber.trim().replace('(', '').replace(')', '').replace('-', '').replace(' ', '').length !== 10) {
      formIsValid = false; errors.mobileNumber = 'Invalid mobile number.';
    }
    if (state.countryCode.trim() === '') { formIsValid = false; errors.countryCode = 'Required.'; }

    if (state.pickupLocation.trim() === '') { formIsValid = false; errors.pickupLocation = 'Please enter pick-up location.'; }
    if (state.pickupZoneId == 0) { formIsValid = false; errors.pickupZoneId = 'Please select pick-up zone.'; }
    if (state.dropoffLocation.trim() === '') { formIsValid = false; errors.dropoffLocation = 'Please enter drop off location.'; }
    if (state.dropoffZoneId == 0) { formIsValid = false; errors.dropoffZoneId = 'Please select drop off zone.'; }

    if (state.puDateTime == null) { formIsValid = false; errors.puDateTime = 'Please enter date time.'; }
    if (state.doDateTime === '') { formIsValid = false; errors.puDateTime = 'Please enter date time.'; }

    if (state.airlineId > 0) {
      if (state.flightNumber.trim() === '') { formIsValid = false; errors.flightNumber = 'Please enter flight #.'; }
      if (state.flightTime == null) { formIsValid = false; errors.flightTime = 'Please enter flight time.'; }
      if (parseInt(state.terminalType) == 0) { formIsValid = false; errors.terminalType = 'Please select terminal type.'; }
    }

    if (state.tripTypeId === '2') {
      if (state.airlineIdReturn > 0) {
        if (state.flightNumberReturn.trim() === '') { formIsValid = false; errors.flightNumberReturn = 'Please enter flight number.'; }
        if (state.flightTimeReturn == null) { formIsValid = false; errors.flightTimeReturn = 'Please enter flight time.'; }
        if (parseInt(state.terminalTypeReturn) == 0) { formIsValid = false; errors.terminalTypeReturn = 'Please select terminal type.'; }
      }
      if (state.puDateTimeReturn == null) { formIsValid = false; errors.puDateTimeReturn = 'Please enter pick-up date time.'; }
      if (parseInt(state.noOfPaxReturn | 0) == 0) { formIsValid = false; errors.noOfPaxReturn = 'Please enter no. of pax.'; }
    }

    if (state.orderByName === '') { formIsValid = false; errors.orderByName = 'Please enter order by.'; }
    if (state.reservationModeId == 0) { formIsValid = false; errors.reservationModeId = 'Please select rez mode.'; }

    if (state.isSendEmail) {
      if (state.email.trim() === '') { formIsValid = false; errors.email = 'Please enter email.'; }
    }
    if (parseInt(state.reservationModeId) == 3 || parseInt(state.paymentTypeId) == 2) {
      if (state.email.trim() === '') { formIsValid = false; errors.email = 'Please enter email.'; }
    }
    if (state.email !== '') {
      const regEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!regEmail.test(state.email)) { formIsValid = false; errors.email = 'Please enter valid email.'; }
    }

    if (vehicleTypeSelectValidatorRef && vehicleTypeSelectValidatorRef.current) {
      if (vehicleTypeSelectValidatorRef.current.instance.option('selectedItem') === null || Number(state.vehicleTypeId) === 0) {
        formIsValid = false;
        errors.vehicleTypeId = 'Please select vehicle type.';
        vehicleTypeSelectValidatorRef.current.instance.focus();
      }
    } else if (Number(state.vehicleTypeId) === 0) {
      formIsValid = false;
      errors.vehicleTypeId = 'Please select vehicle type.';
    }

    if (parseInt(state.noOfTrip | 0) == 0) { formIsValid = false; errors.noOfTrip = 'Please enter no of trip.'; }
    if (parseInt(state.noOfPax | 0) == 0) { formIsValid = false; errors.noOfPax = 'Please enter no of trip.'; }

    if (state.serviceSourceId == 2 || state.serviceSourceId == 3) {
      if (state.otherAffiliateId == 0) { formIsValid = false; errors.otherAffiliateId = 'Please select affiliate.'; }
    }

    if (state.tripTypeId === '3') {
      if (state.recurringEndDate === '' || state.recurringEndDate === null) { formIsValid = false; errors.recurringEndDate = 'Please enter recurring end date.'; }

      if (state.recurringTypeId == 1 && state.selectedDays.length === 0) { formIsValid = false; errors.recurring = 'Please select recurring days.'; }

      if (state.recurringTypeId == 2) {
        if (!state.isWeekSun && !state.isWeekMon && !state.isWeekTue && !state.isWeekWed && !state.isWeekThu && !state.isWeekFri && !state.isWeekSat) {
          formIsValid = false; errors.recurring = 'Please select recurring days.';
        }
      }

      if (state.recurringTypeId == 3) {
        if (!state.isMonthSun && !state.isMonthMon && !state.isMonthTue && !state.isMonthWed && !state.isMonthThu && !state.isMonthFri && !state.isMonthSat) {
          formIsValid = false; errors.recurring = 'Please select recurring days.';
        }
      }
    }

    if (state.paymentTypeId === 0) { formIsValid = false; errors.paymentTypeId = 'Please select payment type.'; }

    if (parseInt(state.chkPaymentGatewaySelection) == 2 && state.paymentTypeId === 2) {
      if (state.creditCard.trim() === '') { formIsValid = false; errors.creditCard = 'Please enter credit card number.'; }
      if (state.cardType === '') { formIsValid = false; errors.cardType = 'Please select card type.'; }
      if (state.cardExpiry === '') { formIsValid = false; errors.cardExpiry = 'Please enter expiry.'; }
    }

    if (state.paymentTypeId === 4) {
      if (state.checkNumber === '') { formIsValid = false; errors.checkNumber = 'Please enter check number.'; }
      if (state.checkBank === '') { formIsValid = false; errors.checkBank = 'Please enter bank name.'; }
      if (state.checkDate === '') { formIsValid = false; errors.checkDate = 'Please enter check date.'; }
    }

    if (state.paymentTypeId === 7) {
      if (state.voucherCompanyId === 0) { formIsValid = false; errors.voucherCompanyId = 'Please select company.'; }
      if (state.voucherCode === '') { formIsValid = false; errors.voucherCode = 'Please enter voucher.'; }
    }

    if (parseInt(state.paymentTypeId) !== 1) {
      if (parseFloat(state.rideAmount) === 0) { formIsValid = false; errors.rideAmount = 'Please enter ride amt.'; }
    }

    if (parseInt(state.mgToPay) === 1) {
      if (state.payMeetGreetId === 0) { formIsValid = false; errors.payMeetGreetId = 'Please select greeter.'; }
      if (parseFloat(state.payMeetGreetAmount) === 0) { formIsValid = false; errors.payMeetGreetAmount = 'Please enter greeter amt.'; }
    }

    if (parseInt(state.paymentTypeId) === 2 || parseInt(state.paymentTypeId) === 3) {
      if (parseInt(state.paymentTermId) == 2) {
        if (parseFloat(state.paidAmount) === 0) { formIsValid = false; errors.paidAmount = 'Please enter paid amt.'; }
      } else {
        if (parseFloat(state.paidAmount) === 0) { formIsValid = false; errors.paidAmount = 'Please first enter ride amount.'; }
      }
    }

    setState({ errors });
    return formIsValid;
  }, [state, setState, vehicleTypeSelectValidatorRef]);

  return { validate };
}
